export const ROLES = {
  GUEST: 'guest',
  PENDING: 'pending',
  STANDARD: 'standard',
  SUPPORT: 'support',
};

const ROLE_HIERARCHY = {
  [ROLES.GUEST]: 0,
  [ROLES.PENDING]: 1,
  [ROLES.STANDARD]: 2,
  [ROLES.SUPPORT]: 3,
};

export const hasRole = (userRole, requiredRole) => {
  return (ROLE_HIERARCHY[userRole] ?? -1) >= (ROLE_HIERARCHY[requiredRole] ?? Infinity);
};

// Connect engagement roles (from AvSight_Connect_Engagement__c.Roles__c). These
// are distinct from the RBAC roles above: they gate visibility of marketplace
// feature tabs (ACON-60) rather than access level.
export const CONNECT_ROLES = {
  PURCHASE: 'purchase',
  LEASE: 'lease',
  INVOICES: 'invoices',
  RMA: 'rma',
  SHIPMENTS: 'shipments',
};

// Case-insensitive membership check against the user's connect roles.
export const hasConnectRole = (connectRoles, required) => {
  if (!Array.isArray(connectRoles)) return false;
  const needle = String(required).trim().toLowerCase();
  return connectRoles.some((r) => String(r).trim().toLowerCase() === needle);
};
